import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/resume_profile/`, data);
};

const get = async (id) => {
  return await httpClient.get(`/resume_profile/${id}/`);
};

const put = async (id, data) => {
  return await httpClient.put(`/resume_profile/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/resume_profile/${id}`);
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `/resume_profile/export${query}&sort=${sortBy}${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/resume_profile${query}&page[number]=${page}&page[size]=${pageSize}&sort=${sortBy}${searchBy}`,
    );
};

const generatePDF = async (id) => {
  return await httpClient.get(`/resume_profile/${id}/generate_pdf/`);
};

export { post, get, put, remove, ajaxTable, generatePDF };
